import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routeEndpoints } from "../routes/routeEndpoints";

export const useGoBack = (fallback: string = routeEndpoints.landing) => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    const historyIndex = (window.history.state?.idx as number | undefined) ?? 0;
    const canGoBack = location.key !== "default" && historyIndex > 0;

    if (canGoBack) {
      navigate(-1);
    } else {
      navigate(fallback, { replace: true });
    }
  }, [navigate, location.key, fallback]);
};
